
    <demo *ngIf="isDemo$ | async"></demo>
    <navbar
      [isLoggedIn]="isLoggedIn$ | async"
      [isPrivateOrgMode]="isPrivateOrgMode$ | async"
      [hasGroupInvites]="hasGroupInvites$ | async"
      (logout)="logout()"
      *ngIf="isVisible"
    ></navbar>
  